/* eslint-disable */
import Swal from 'sweetalert2'

export const Toast = Swal.mixin({
  position: 'center',
  showConfirmButton: true,
  timmer: 1000
})